import React, { Component, Fragment } from 'react';
import { Field, FormSpy } from 'react-final-form';
import { map, prop, objOf } from 'ramda';

import {
    metroOccupationType,
    metroChartOfWork,
    yesnocombo,
    metroRecruiters,
    metroCompetence,
    metroHRGeneralist,
    metroHRBP,
    metroHRM,
    metroHRBPOperations,
} from 'constants/dictionaries';
import {
    METRO_REQUEST_STORE,
    METRO_REQUEST_HQ,

    METRO_REQUEST_ROUTES_FILTERS,
} from 'constants/metro';
import Input from 'components/common/form/Input';
import Text from 'components/common/form/Text';
import { SelectLoadComponent } from 'components/common/form/Select';
import { RadioButtonsLoad } from 'components/common/form/RadioButtons';
import { TranslateFormField } from 'components/common/fields/TranslateField';
import { maxLength } from 'utils/validators';

export default class PositionFields extends Component {
    render() {
        const { filters, routeType, disabled, positionDisabled, approvalEdit, isCNB, getChangeField } = this.props;

        return <Fragment>
            <Field
                name='position'
                component={Input}
                label={{ content: 'metro.request.position', required: true }}
                disabled={positionDisabled}
                showValidationErrors
            />
            <Field
                name='positionEngl'
                component={Input}
                label={{ content: 'metro.request.positionEngl' }}
                disabled={positionDisabled}
                showValidationErrors
            />
            <FormSpy>
                {({ values: { chief, chiefPosition, chiefEngl, chiefPositionEngl } }) => (
                    <Fragment>
                        <TranslateFormField
                            ru={chief}
                            en={chiefEngl}
                            label='metro.request.chief'
                        />
                        <TranslateFormField
                            ru={chiefPosition}
                            en={chiefPositionEngl}
                            label='metro.request.chiefPosition'
                        />
                    </Fragment>
                )}
            </FormSpy>
            { isCNB && (
                <Field
                    name='chiefCode'
                    component={Input}
                    label={{ content: 'metro.request.chiefCode' }}
                    disabled={true}
                />
            )}
            <Field
                name='occupationTypeCode'
                component={SelectLoadComponent}
                loadName={metroOccupationType}
                label={{ content: 'metro.request.occupationType' }}
                disabled={disabled && !approvalEdit}
                allowClear
            />
            <Field
                name='chartOfWorkCode'
                component={SelectLoadComponent}
                loadName={metroChartOfWork}
                label={{ content: 'metro.request.chartOfWork' }}
                disabled={disabled && !approvalEdit}
                allowClear
            />
            <Field
                name='contractPeriod'
                component={Input}
                label={{ content: 'metro.request.contractPeriod' }}
                disabled={disabled && !approvalEdit}
                showValidationErrors
            />
            <Field
                name='mobilePhoneCode'
                component={RadioButtonsLoad}
                loadName={yesnocombo}
                label={{ content: 'metro.request.mobilePhone' }}
                disabled={disabled && !approvalEdit}
            />

            <hr />

            { routeType === METRO_REQUEST_STORE ? (
                <Field
                    name={'HRGeneralistCode'}
                    component={SelectLoadComponent}
                    loadName={metroHRM}
                    loadParams={{
                        type: METRO_REQUEST_ROUTES_FILTERS[routeType],
                        addCode: filters.storeCode,
                    }}
                    label={{ content: 'metro.request.HRM'}}
                    disabled={true}
                />
            ) : (
                <Field
                    name={'HRGeneralistCode'}
                    loadName={metroHRGeneralist}
                    loadParams={{
                        type: METRO_REQUEST_ROUTES_FILTERS[routeType],
                        URLEncfuncOrRegion: filters.directorateEngl,
                    }}
                    component={SelectLoadComponent}
                    label={{ content: 'metro.request.HQHRGeneralist' }}
                    disabled={disabled}
                />
            )}
            <Field
                name='HRBPCode'
                loadName={metroHRBP}
                loadParams={{
                    type: METRO_REQUEST_ROUTES_FILTERS[routeType],
                    URLEncfuncOrRegion: routeType === METRO_REQUEST_STORE ? filters.region : filters.directorateEngl
                }}
                component={SelectLoadComponent}
                label={{ content: 'metro.request.HQHRBP' }}
                disabled={disabled || routeType === METRO_REQUEST_STORE}
            />
            <FormSpy>
                {({ values: { recruiter } }) => (
                    <Field
                        name='recruiterCode'
                        component={SelectLoadComponent}
                        loadName={metroRecruiters}
                        label={{ content: 'metro.request.recruiter' }}
                        onChange={getChangeField('recruiter')}
                        disabled={disabled || routeType === METRO_REQUEST_HQ}
                        placeholderDefault
                        placeholder={recruiter || null}
                    />
                )}
            </FormSpy>

            { routeType === METRO_REQUEST_STORE && (
                <Field
                    name='HRBPOperationsCode'
                    loadName={metroHRBPOperations}
                    loadParams={{
                        addCode: filters.storeCode,
                        URLEncfuncOrRegion: filters.region,
                    }}
                    component={SelectLoadComponent}
                    label={{ content: 'metro.request.HRBPOperations' }}
                    disabled={disabled && !approvalEdit}
                />
            )}

            <hr />

            <Field
                name='responsibilities'
                component={Text}
                label={{ content: 'metro.request.responsibilities' }}
                disabled={disabled && !approvalEdit}
                showValidationErrors
                validate={maxLength(2500)}
            />
            <Field
                name='requirements'
                component={Text}
                label={{ content: 'metro.request.requirements' }}
                disabled={disabled && !approvalEdit}
                showValidationErrors
                validate={maxLength(1000)}
            />
            <Field
                name='competences'
                component={SelectLoadComponent}
                multi={true}
                allowClear={true}
                loadName={metroCompetence}
                stringifyValue={false}
                valueTransformer={map(prop('id'))}
                onChangeTransformer={map(objOf('id'))}
                label={{ content: 'metro.request.competences' }}
                disabled={disabled && !approvalEdit}
            />
        </Fragment>;
    }
}
